<script setup>
import { RouterView } from "vue-router";
const back = (lv) => {
  if (lv) {
    window.history.go(lv);
  } else {
    window.history.go(-1);
  }
};
</script>
<template>
  <div class="view">
    <router-view v-slot="{ Component, route }">
      <div class="bar" v-if="route.meta.navBar">
        <div class="bar_left" @click="back(route.meta.back)"></div>
        <div class="bar_text">{{ route.meta.title }}</div>
      </div>
      <div class="content">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </div>
    </router-view>
  </div>
</template>
<style scoped lang="scss">
.view {
  height: 100vh;
  .bar {
    height: 50px;

    .bar_left {
      position: absolute;
      left: 20px;
      top: 20px;
      width: 10px;
      height: 10px;
      transform: rotate(-315deg);
      border: 1px solid;
      border-color: transparent transparent rgba(0, 0, 0) rgba(0, 0, 0);
    }

    .bar_text {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      font-size: 16px;
      line-height: 50px;
      color: #000000;
      font-weight: 600;
    }
  }
}
</style>
